import React, {
  Fragment,
  useState,
  useCallback,
  useMemo,
  useEffect,
} from "react";
import differenceBy from "lodash/differenceBy";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Badge,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Label,
} from "reactstrap";
import SingleSelect from "../../SingleSelect/SingleSelect";
import { Btn, H5,  } from "../../../AbstractElements";
import DatePicker from 'react-datepicker';
import axios from "axios";


const user_options = ["Name", "Province", "District", "Type"];

const FilterComponent = ({
  filterText,
  onFilter,
  onClear,
  userOption,
  setSelectedUserOption,
  t,
}) => (
  <div style={{ display: "flex", flexDirection: "row" }}>
    <SingleSelect
      options={user_options}
      selectedOption={userOption}
      onChange={setSelectedUserOption}
    />
        {userOption === 'Type' ?
      <SingleSelect
        options={["New membership", "Renew membership", "Provincial Fee", "AGM"]}
        selectedOption={filterText}
        onChange={(e) => onFilter({ target: { value: e } })}
      />
      : <>
    <input
      className="form-control"
      placeholder={
        userOption === "District"
          ? t("Filter by District")
          : userOption === "Name"
          ? t("Filter by Name")
          : userOption === "Province"
          ? t("Filter by Province")
          : t("Filter by Status")
      }
      aria-label="Search Input"
      style={{ width: "250px", paddingLeft: "5px" }}
      name="phone"
      id="search"
      type="text"
      value={filterText}
      onChange={onFilter}
    />
    <Btn attrBtn={{ onClick: onClear }} type="button">
      X
    </Btn>
    </>}
  </div>
);

const DataTablesContain = () => {
  const token = localStorage?.getItem("token");
  const [data, setData] = useState();
  const [user_id, setUserId] = useState();
  const { t } = useTranslation();
  const pres = localStorage.getItem("pres");
  const [startDate, setstartDate] = useState(
    new Date()
  );
  const handleChange = date => {
    setstartDate(date);
  };
  const [endDate, setEndDate] = useState(new Date());
  const handleChange2 = date => {
    setEndDate(date);
  };
  const [modal, setModal] = useState(false);
  const [userOption, setSelectedUserOption] = useState("Name");
  const toggle = (e) => {
    e.preventDefault();
    setModal(!modal);
  };
  const [filteredItems, setFilteredItems] = useState();
  useEffect(() => {
    handle_get_firms();

  }, []);

  const handle_get_firms = async () => {
    try {
      const response2 = await axios.get(
        "https://api-portal.nada.org.np/api/proxies/proxy/receipts",
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response2?.data?.success) {
        //const filteredFirms = response2?.data?.data?.receipts?.filter(item => item?.status === 3);
        setData(response2?.data?.data?.receipts);
        setFilteredItems(response2?.data?.data?.receipts);
      }
    } catch (error) {
      if (error.response) {
        console.error("Error response:", error.response);
        toast.error(error?.response?.data?.message || "An error occurred");
      } else if (error?.request) {
        console.error("Error request:", error?.request);
        toast.error("No response received from server");
      } else {
        console.error("Error message:", error?.message);
        toast.error(error?.message);
      }
    }
  };
  const navigate = useNavigate();
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);

  const contextActions = useMemo(() => {
    const handleDelete = () => {
      if (
        window.confirm(
          `Are you sure you want to delete:\r ${selectedRows.map(
            (r) => r.name
          )}?`
        )
      ) {
        setToggleCleared(!toggleCleared);
        setData(differenceBy(data, selectedRows, "name"));
        toast.success("Successfully Deleted !");
      }
    };

    return (
      <Btn attrBtn={{ color: "danger", onClick: handleDelete }} key="delete">
        Delete
      </Btn>
    );
  }, [data, selectedRows, toggleCleared]);

  const handleClick = (link, e) => {
    e.preventDefault();
    window.open(link, "_blank", "noopener,noreferrer");
  };

  const renderStatusBadge = (status) => {
    if (status === 1) {
      return <p>New membership</p>;
    } else if (status === 2) {
      return <p>Renew membership</p>;
    } else if(status === 4) {
      return <p>Provincial Fee</p>;
    } else {
      return <p>AGM</p>;
    }
  };

  const renderStatusBadge2 = (link) => {
    return (
      <>
        {link !== null?
           <Btn
           attrBtn={{
             color: "primary",
             onClick: (e) => handleClick(link, e),
           }}
           style={{
             display: "flex",
             alignItems: "center",
             justifyContent: "center",
           }}
         >
           View Payment Proof
         </Btn>
         : <H5>No proof</H5>
        }
      </>

    );
  };

  const renderStatusBadge3 = (link) => {
    return (
      <Btn
        attrBtn={{
          color: "primary",
          onClick: (e) => handleClick(link, e),
        }}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        View Receipt
      </Btn>
    );
  };

  const customStyles = {
    headCells: {
      style: {
        height: "80px",
        fontSize: "20px", // Change font size
        fontWeight: "bold", // Make it bold
        color: "#333", // Optional: Change text color
        backgroundColor: "#f5f5f5", // Optional: Change background color
      },
    },
  };

  const tableColumns = [
    {
      name: t("ID"),
      selector: (Row) => Row["id"],
      sortable: true,
      center: true,
    },
    {
      name: t("Name"),
      selector: (Row) => Row["name_of_firm"],
      sortable: true,
      center: true,
    },
    {
      name: t("Payment Type"),
      selector: (Row) => renderStatusBadge(Row["payment_type"]),
      sortable: true,
      center: true,
    },
    {
      name: t("Created Date"),
      selector: (Row) => Row["date"],
      sortable: true,
      center: true,
    },
    {
      name: t("Payment Proof"),
      selector: (Row) => renderStatusBadge2(Row["payment_proof"]),
      sortable: true,
      center: true,
    },
    {
      name: t("Receipt"),
      selector: (Row) => renderStatusBadge3(Row["receipt"]),
      sortable: true,
      center: true,
    },
  ];

  const handleRowSelected = useCallback((state) => {
    setSelectedRows(state.selectedRows);
  }, []);

  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);

  const subHeaderComponentMemo = React.useMemo(() => {
    if (filterText === "") {
      setFilteredItems(data);
    } else {
      setFilteredItems(
        userOption === "Name"
          ? data?.filter((item) =>
              item?.name_of_firm
                ?.toLowerCase()
                ?.includes(filterText?.toLowerCase())
            )
          : userOption === "Province"
          ? data?.filter((item) =>
              item?.province?.toLowerCase()?.includes(filterText?.toLowerCase())
            )
          : userOption === "District"
          ? data?.filter((item) =>
              item?.district?.toLowerCase()?.includes(filterText?.toLowerCase())
            )
            : userOption === "Type"
            ? data?.filter((item) =>
              String(item?.payment_type === 1? 'New membership' : item?.payment_type === 2?  'Renew membership' : item?.payment_type === 3?  'AGM' : item?.payment_type === 4?  'Provincial Fee' : 'Send For Edits')?.toLowerCase()?.includes(filterText?.toLowerCase())
              )
          : data?.filter((item) =>
              String(
                item?.status === 1
                  ? "Submitted"
                  : item?.status === 2
                  ? "Send For Edits"
                  : item?.status === 3
                  ? "Accepted"
                  : item?.status === 4
                  ? "Rejected"
                  : "Send For Edits"
              )
                ?.toLowerCase()
                ?.includes(filterText?.toLowerCase())
            )
      );
    }

    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <FilterComponent
        onFilter={(e) => setFilterText(e.target.value)}
        onClear={handleClear}
        t={t}
        userOption={userOption}
        setSelectedUserOption={setSelectedUserOption}
        filterText={filterText}
      />
    );
  }, [filterText, resetPaginationToggle, userOption, data, t]);

  const  handle_filter_date = async (e) => {
    e.preventDefault();
    setModal(!modal);
    console.log('start date------', startDate, endDate);
    const startDate1 = new Date(startDate);
const endDate2 = new Date(endDate);

const filteredByDate = data?.filter((item) => {
  const itemDate = new Date(item?.date); // Convert the API date to a Date object
  return itemDate >= startDate1 && itemDate <= endDate2; // Check if the date is within the range
});

setFilteredItems(filteredByDate);
  };

  return (
    <Fragment>
      <Container fluid={true} className="data-tables">
        <Row>
          <Col sm="12">
            <Card>
              <CardHeader
                className="pb-0"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <H5>{t("Receipts")}</H5>
                {/*
                  <Btn
                    attrBtn={{ color: "primary", onClick: handleAddNewClick }}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    Add New
                  </Btn>
                */}
                <div style={{ display: "flex", flexDirection: "row", gap: 10 }}>
                  <Btn
                    attrBtn={{ color: "secondary", onClick: toggle }}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {t("Filter By Date")}
                  </Btn>
                </div>
              </CardHeader>
              <CardBody>
                {data && (
                  <DataTable
                    data={filteredItems}
                    columns={tableColumns}
                    striped={true}
                    center={true}
                    persistTableHead
                    subHeader
                    selectableRows
                    subHeaderComponent={subHeaderComponentMemo}
                    paginationResetDefaultPage={resetPaginationToggle}
                    onSelectedRowsChange={handleRowSelected}
                    clearSelectedRows={toggleCleared}
                    pagination
                    customStyles={customStyles}
                  />
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      <Modal isOpen={modal} toggle={toggle}
      //size={props.size}
      centered
      >
      <ModalHeader toggle={toggle}>
      {t("Set Proxy Date")}
      </ModalHeader>
      <ModalBody
        style={{ flexDirection: 'column', display: 'flex', gap: 10}}
      //className={props.bodyClass}
      >
        <div
          style={{ flexDirection: 'row', display: 'flex', gap: 20, alignItems: 'center'}}
        >
        <Label className="form-label">{t("Start Date & Time")}</Label>
        <DatePicker className="form-control digits" showPopperArrow={false} selected={startDate} showTimeSelect dateFormat="Pp" onChange={handleChange} />
        </div>
        <div
          style={{ flexDirection: 'row', display: 'flex', gap: 20, alignItems: 'center'}}
        >
        <Label className="form-label">{t("End Date & Time")}</Label>
        <DatePicker className="form-control digits" showPopperArrow={false} selected={endDate} showTimeSelect dateFormat="Pp" onChange={handleChange2} />
        </div>
      </ModalBody>
      <ModalFooter>
        <Btn attrBtn={{ color: 'secondary', onClick: toggle, height: 65 }} >{t("Close")}</Btn>
        <Btn attrBtn={{
          color: 'primary',
          onClick: (e)=> handle_filter_date(e),
          outerHeight: 65 }}>
            {t("Filter")}
          </Btn>
      </ModalFooter>
    </Modal>
    </Fragment>
  );
};
export default DataTablesContain;
